






































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import LocationDetailModal from '../modals/LocationDetailModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'locations',
    data: function () {
        return {
            locationsPage_: 1,
        };
    },
    components: {
        LocationDetailModal,
        Spinner,
    },
    filters: {},
    computed: {
        ...mapState('locations', ['allLocations', 'allLocationsLoading', 'locationsPerPage', 'locationsPage', 'locationsTotal']),
        // ...mapState('locations', {
        //     allLocations: (state: any) => {
        //         const allLocations = state.allLocations.map((location: any) => {
        //             location.visible = location.visible ? 'Activa' : 'Inactiva';
        //             return location;
        //         });
        //         return allLocations;
        //     },
        // }),
    },
})
export default class Locations extends Vue {
    public allLocations!: any;
    public allLocationsLoading!: any;
    public locationsPerPage!: any;
    public locationsPage!: any;
    public locationsPage_!: any;
    public location_word_search: any = '';
    public locationsTotal!: any;
    private activeLocationLoaded: boolean = false;
    allLocationsHeaders = [
        { thClass: 'th', key: 'name', label: 'Sucursal' },
        { thClass: 'th', key: 'address', label: 'Dirección' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    setUrlPage(page: any) {
        this.$router.push({
            path: 'locations',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.locationsPage_ = page;
    }

    setUrlSearch(search: string) {
        search = search.trim();
        this.$router.push({
            path: 'locations',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    clearFilters() {
        this.location_word_search = '';
        this.$router.push({
            path: 'locations',
            query: {},
        });
        this.locationsPage_ = 1;
    }

    onOpenLocationModal(id: string | null = null) {
        this.$store.dispatch('locations/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('location-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllLocations() {
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const location_status_filter = this.$route.query.location_status_filter || null;
        this.$store.dispatch('locations/getAll', {
            page,
            search,
            location_status_filter,
        });
    }

    mounted() {
        this.getAllLocations();
        this.locationsPage_ = 1;
    }
}
